import { useMediaQuery } from 'react-responsive';
import { useTheme } from 'styled-components';
import { BreakpointSizes } from 'theme/';

export const useBreakpoint = (size: BreakpointSizes): boolean => {
  const { breakpoint } = useTheme();
  return useMediaQuery({ maxWidth: breakpoint[size] });
};
